export default {
      id: "known-wallet-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#known-wallet",
      toString: function () {
        return this.url;
      }
    }